<p-dialog
  header="{{ confirmDialogContent.head | translate }}"
  [(visible)]="confirmDialogContent.showConfirmDialog"
  [style]="{ width: '34vw' }"
  [modal]="true"
  styleClass="{{ confirmDialogContent.styleClass }}"
  [draggable]="false"
>
  <div class="mb-2">
    <p class="leading-6">
      {{ confirmDialogContent.description | translate }}
    </p>
  </div>
  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-3">
      <app-button-secondary
        (actionButtonCall)="alertBtnAction(false)"
        buttonCaption="{{ confirmDialogContent.btnCancel | translate }}"
        buttonClassName="xs-medium"
      ></app-button-secondary>
      <app-button-primary
        buttonCaption="{{ confirmDialogContent.btnProceed | translate }}"
        (actionButtonCall)="alertBtnAction(true)"
        buttonClassName="xs-medium"
      ></app-button-primary>
    </div>
  </ng-template>
</p-dialog>
